import {ensureNotObject} from "../common";
import {Account} from "../../../../../contexts/chartofaccounts/ChartOfAccountsContext";
import {DistributionMethod, MonthlyAverageBasePeriod} from "../../../../../__generated__/generated_types";

export function renderOperationalMonthValue(
    month: number,
    metric: {id: string, name: string} | undefined,
    percent: any,
    amount: any
): string {
    return `Month ${month}: ${ensureNotObject(percent)}% ${metric ? metric.name : "--UNKNOWN--"} with cost $${ensureNotObject(amount)}`;
}

export function renderAccountPercentageMonthValue(month: number, account: Account | undefined, percent: any): string {
    return `Month ${month}: ${ensureNotObject(percent)}% of ${account ? account.name : "--UNKNOWN--"}`;
}

export function renderCustomMonthlyValue(month: number, count: any, amount: any, percent: any): string {
    return `Month ${month}: ${ensureNotObject(count)} at ${ensureNotObject(percent)}% with cost $${ensureNotObject(amount)}`;
}

export function renderDistributionMethod(distributionMethod: string): string {
    switch(distributionMethod) {
        case DistributionMethod.Flat:
            return "Even";
        case DistributionMethod.Seasonal:
            return "Seasonal";
        default:
            return "";
    }
}

export function renderMonthlyAvgBasePeriod(basePeriod: string): string {
    switch(basePeriod) {
        case MonthlyAverageBasePeriod.CustomLookbackPeriod:
            return "Custom";
        case MonthlyAverageBasePeriod.LastMonth:
            return "Last Month";
        case MonthlyAverageBasePeriod.LastSixMonthsActuals:
            return "Last 6 Months of Actuals";
        case MonthlyAverageBasePeriod.LastThreeMonthsActuals:
            return "Last 3 Months of Actuals";
        case MonthlyAverageBasePeriod.LastTwelveMonthsActuals:
            return "Last 12 Months of Actuals";
        default:
            return "";
    }
}